
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"

import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"
// endregion External Modules

// Private Modules
import Modal from "app/modal/show-modal"
import Google_Event from "app/tracking/google/event"
import DataRetriever from "app/data_retriever"
import PageInstance from "app/page_instance/index"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import RemoteSubmitForm from "./components/remote_submit_form/index"
import GA4_Event from "app/tracking/google/google_analytics_4/event"
// endregion Private Components

// endregion JS Imports



/* eslint-disable no-unused-vars */
export enum FollowTypes {
  RESIDENTIAL = "residential",
  COMMERCIAL  = "commercial",
}
/* eslint-enable no-unused-vars */

const CELL_CLASS_NAME = "cell--buildings--following--modal"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = (scope: string | JQuery = `.${CELL_CLASS_NAME}`, follow_type: FollowTypes) => {
  $(scope).each((idx, el) => {
    const $el = $(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    RemoteSubmitForm.init(
      {
        container: $el,
      },
      {
        follow_type: follow_type,
      },
    )
  })
}

const show = (follow_type: FollowTypes) => {
  const city_id = DataRetriever.get("current-city-id")
  const neighbourhood_id = DataRetriever.get("neighbourhood-id")
  const building_id = DataRetriever.get("building-id")

  // Special treatment when accessed through google translate
  if (city_id == null || neighbourhood_id == null || building_id == null) {
    return
  }

  const url = Routes.follow_city_neighbourhood_building_path(I18n.locale, city_id, neighbourhood_id, building_id, {
    follow_type: follow_type,
  })

  q_ajax_3({
    url:      url,
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    if (u(`.${CELL_CLASS_NAME}`).length !== 0) { return }
    const $modal = Modal.showModalWithContent(data, {customContent: true})

    init($modal, follow_type)
    // Tracking
    Google_Event.track({
      category: PageInstance.currentPageNameForTracking(),
      action:   "Follow Building",
      options:  {
        eventLabel: "Modal Pop Up",
      },
    })

    GA4_Event.track({
      event_name: "building_follow_modal_displayed",
      options:    {
        page: PageInstance.currentPageNameForTracking(),
      },
    })
  })
  .done()
}


export default {
  show,
}
